<template>
  <div class="box3-container">
    <div class="title">网关二实时数据</div>
    <div class="content">
      <el-scrollbar class="scroll_box">
          <p class="red"><em class="block_bg red_bg">ERROR</em>网关2 连接失败  <span class="grap">{{nowDate.hour}}:{{nowDate.minute}} {{nowDate.second}}</span></p>
        </el-scrollbar>
    </div>
  </div>
</template>
<script>
export default {
  name: "Box3",
  data() {
    return {
      nowDate: {
        year: '',
        month: '',
        day: '',
        week: '',
        hour: '',
        minute: '',
        second: '',
      },
    }
  },
  mounted() {
    this.formatDate();
  },
  methods:{
    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; //月
      let day = date.getDate(); // 日
      let week = date.getDay(); // 星期
      let weekArr = [ "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六" ];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      this.nowDate = {
        year: year,
        month: month,
        day: day,
        week: weekArr[week],
        hour: hour,
        minute: minute,
        second: second
      }
    }
  }
};
</script>
<style lang='less'>
.box3-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: #06113c;
  padding:15px 5px 5px 5px;
  box-sizing: border-box;
  .title {
    font-size: 18px;
    line-height: 35px;
    font-weight: normal;
    color: #fff;
    display: block;
    width: 100%;
    height:35px;
    text-align: center;
    background: url(../../assets/images/title_bg.png) center top no-repeat;
    background-size: auto 100%;
  }
  .content {
    position: absolute;
    top: 60px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    padding:10px;
    background: #030b28;
    .scroll_box{
      width:100%;
      height:100%;
      font-size:12px;
      color:#fff;
      line-height: 1.4;
      font-family: Microsoft yahei;
      em,span,h1{
        font-style: normal;
      }
      p{
        margin:12px 0 0;
      }
      span{
        margin-left:10px;
      }
      .block_bg{
        background: #0dbc79;
        display: inline-block;
        padding:1px 5px;
        color:#000;
        margin-right: 10px;
      }
      .green{
        color:#0dbc79
      }
      .green_bg{
        background:#0dbc79
      }
      .red{
        color:#cd3131
      }
      .red_bg{
        background:#cd3131
      }
      .blue{
        color:#2472c8
      }
      .blue_bg{
        background:#2472c8
      }
      .grap{
        color:#919191
      }
    }
  }
}

.el-scrollbar__wrap{
  overflow-x: hidden !important;
}
.is-horizontal{
  display: none;
}
// /deep/ .el-scrollbar__wrap {
// overflow-x: hidden;
// }
</style>

